module.exports = __webpack_public_path__ + "files/955d46afa821ad424b2afb930725f576.png";